/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 17.11.17.
 */

import React from "react";
import PropTypes from "prop-types";
import CONFIG from "../config";
import Notify from "../containers/Notify";
import {t} from "../trans";
import ResetPassword from "../modals/ResetPassword";
import Navigation from "../Navigation";

class Forgot extends React.Component {
    static propTypes = {
        params: PropTypes.shape({
            authToken: PropTypes.string.isRequired
        }).isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
        this.state.modal = null;
        this.onClose = this.onClose.bind(this);
    }

    onClose() {
        Navigation.gotoMain();
    }


    render() {
        return (
            <div className="gray-bg" style={{position: "relative", minHeight: "100%"}}>
                <div className="middle-box text-center loginscreen animated fadeInDown">
                    <div/>
                    <p className="m-t">
                        <small>{t(CONFIG.copyright)}</small>
                    </p>
                </div>
                <ResetPassword type="forgot" authToken={this.props.params.authToken} onClose={this.onClose}/>
                <Notify/>
            </div>
        );
    }
}

export default Forgot;
